<template>
    <div v-if="ratingValue != null">
        <span class="full-width">{{ label }}</span>
        <span class="full-width">{{ starRatingWithComma }} / {{ maxStars }} {{ $t("App.StarRating.Stars") }}</span>
        <div class="star-icons">
            <img
                v-for="index in filledStars"
                :key="'a' + index"
                class="star-icon"
                :src="filledStarIcon"
                :alt="filledStarIconAlt"
                aria-hidden="true"
            >
            <img
                v-if="halfFilledStar"
                class="star-icon"
                :src="halfFilledStarIcon"
                :alt="halfFilledStarIconAlt"
                aria-hidden="true"
            >
            <img
                v-for="index in emptyStars"
                :key="'b' + index"
                class="star-icon"
                :src="unfilledStarIcon"
                :alt="unfilledStarIconAlt"
                aria-hidden="true"
            >
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop, Watch } from "vue-facing-decorator"

    @Component
    export default class StarRating extends Vue {
        @Prop({ type: Number }) ratingValue: number | undefined
        @Prop() label: string | undefined
        filledStars: number = 0
        halfFilledStar: boolean = false
        emptyStars: number = 0
        maxStars: number = 5
        starRatingWithComma: string = ""

        mounted(): void {
            this.updateStarRating()
        }

        get starRating(): number | undefined {
            return this.ratingValue
        }

        @Watch("ratingValue")
        onRatingValueChange(): void {
            this.updateStarRating()
        }

        updateStarRating(): void { // TODO OKo: Miksi tulee index virheitä
            if (this.ratingValue != null) {
                this.starRatingWithComma = this.ratingValue.toString().replace(".", ",")
                this.filledStars = Math.floor(this.ratingValue)
                this.halfFilledStar = this.ratingValue % 1 !== 0
                this.emptyStars = this.maxStars - Math.ceil(this.ratingValue)
            }
        }

        get filledStarIcon(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/star-filled.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get filledStarIconAlt(): string | undefined {
            return this.$t("App.StarRating.FilledStarIcon.AltText")
        }

        get halfFilledStarIcon(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/star-half-filled.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get halfFilledStarIconAlt(): string | undefined {
            return this.$t("App.StarRating.HalfFilledStarIcon.AltText")
        }

        get unfilledStarIcon(): string {
            return this.$store.getters.contentServiceUrl + "/Content/icons/svg-blue/star-not-filled.svg" + "?" + this.$store.getters.contentServiceTimeStamp
        }

        get unfilledStarIconAlt(): string | undefined {
            return this.$t("App.StarRating.UnfilledStarIcon.AltText")
        }
    }
</script>

<style scoped>
    .full-width {
        display: block;
    }

    .star-icons {
        margin-top: 5px;
    }
</style>
